import styled from 'styled-components';

export const ClientsTableStyled = styled.div`
  position: relative;
`;

export const Email = styled.a`
  color: ${({ theme }) => theme.colors.primary[500]};
`;
